


export const rewindowSeriesToMonthly=(data)=>{
  // Sort the data array by date in ascending order
  data.sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));

  // Create an object to store the last object for each month
  const monthlyData = {};

  // Iterate over each object in the data array
  for (const obj of data) {
    const date = new Date(obj.timestamp);
    const yearMonth = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;

    // Update the last object for the corresponding month
    monthlyData[yearMonth] = obj;
  }

  // Convert the monthlyData object to an array
  const result = Object.values(monthlyData);

  return result;
}


export const filterSeriesBetweenRange = (data, startDate, endDate) => {
  // Filter the data array based on the timestamp range
  const filteredData = data.filter(obj => {
    const date = new Date(obj.timestamp);
    return date >= startDate && date <= endDate;
  });

  return filteredData;
};


export const findCommonTimestampsAndFilter = (arrays)=>{
    if (arrays.length === 0) return [];

    // Step 1: Get the set of all timestamps in the first array
    let commonTimestamps = new Set(arrays[0].map(obj => obj.timestamp));

    // Step 2: Intersect with timestamps from the other arrays
    for (let i = 1; i < arrays.length; i++) {
        const currentTimestamps = new Set(arrays[i].map(obj => obj.timestamp));
        commonTimestamps = new Set([...commonTimestamps].filter(timestamp => currentTimestamps.has(timestamp)));
    }

    // Step 3: Filter each array to keep only objects with common timestamps
    return arrays.map(array => array.filter(obj => commonTimestamps.has(obj.timestamp)));
}
